import _ from 'lodash';
import sift from 'sift';
import { getMongoDbQuery } from '@skyjs/query';
import isLodashCompatibleCriteria from './isLodashCompatibleCriteria.js';
import customOperations from './customOperations.js';

export default function createTester(criteria) {
  const query = getMongoDbQuery(criteria);
  if (isLodashCompatibleCriteria(criteria, query)) {
    // console.log('using lodash directly', criteria, query);
    return obj => _.isMatch(obj, criteria);
  } else {
    // console.log('using sift', criteria, query);
    return sift(query, customOperations);
  }
}
